module.exports = "dt {\n  opacity: 0.5; }\n\nh3 {\n  margin-top: 0; }\n"